<div #editorContainer class="editor-container"></div>